import { useEffect, useState } from 'react'
import { Typography, Grid } from '@material-ui/core'

import Api from '../../../Apis/api.service'
import ProcessCard from '../../../components/common/Cards/ProcessCard'

const Mec = ({ copro, coproprietaire }) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const MECContent = ({ record, coproprietaire }) => {
    if (!record)
      return (
        <Typography>Vous retrouverez ici les mises en concurrence.</Typography>
      )
    return (
      <>
        <div key={'list_tickets_mec'} style={{ width: '100%' }}>
          <ProcessCard
            tickets={data}
            processName="Mise en concurrence"
            coproprietaire={coproprietaire}
          />
        </div>
      </>
    )
  }

  const fetchData = async (params) => {
    setIsLoading(true)
    const res = await Api.tickets.getMecTickets({ ...params })
    if (res.status == 200) {
      setData(res.data)
    }
    setIsLoading(false)
  }
  useEffect(() => {
    fetchData({
      filter: {
        copro_id: copro.copros_monday_internal_id,
      },
      sort: ['id', 'ASC'],
    })
  }, [copro])
  return (
    <>
      <Grid container style={{ alignItems: 'center' }}>
        <MECContent record={data} coproprietaire={coproprietaire} />
      </Grid>
    </>
  )
}

export default Mec
